import PropTypes from 'prop-types'
import PublicNav from './PublicNav'
import Footer from './Footer'

const PrivacyPolicy = ({ onBack, onLogin, onShowFeatures, onShowPricing, onShowAbout, onShowContact, onShowTerms }) => {
  return (
    <div className="min-h-screen bg-gray-950">
      <PublicNav 
        onShowFeatures={onShowFeatures}
        onShowPricing={onShowPricing}
        onLogin={onLogin}
        onBack={onBack}
        activeProduct={false}
        activePricing={false}
        activeHome={false}
      />

      <div className="relative py-24">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="font-display text-5xl font-light tracking-tight text-white sm:text-7xl mb-6">
              Privacy <span className="text-sky-300">Policy</span>
            </h1>
            <p className="mx-auto max-w-3xl text-xl text-gray-400">
              Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
            </p>
          </div>

          <div className="prose prose-invert prose-lg max-w-none">
            <div className="space-y-8 text-gray-300">
              <section>
                <h2 className="font-display text-2xl font-light tracking-tight text-white mb-4">1. Information We Collect</h2>
                <p>We collect information that you provide directly to us, including:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Account information (email address, name)</li>
                  <li>Ideas and business concepts you submit</li>
                  <li>Communications you send to us</li>
                  <li>Usage data and analytics</li>
                </ul>
              </section>

              <section>
                <h2 className="font-display text-2xl font-light tracking-tight text-white mb-4">2. How We Use Your Information</h2>
                <p>We use the information we collect to:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Provide and improve our services</li>
                  <li>Process and analyze your business ideas</li>
                  <li>Communicate with you about our services</li>
                  <li>Ensure the security of our platform</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </section>

              <section>
                <h2 className="font-display text-2xl font-light tracking-tight text-white mb-4">3. Data Security</h2>
                <p>
                  We implement appropriate technical and organizational measures to protect your personal data 
                  against unauthorized access, alteration, disclosure, or destruction. However, no method of 
                  transmission over the internet is 100% secure.
                </p>
              </section>

              <section>
                <h2 className="font-display text-2xl font-light tracking-tight text-white mb-4">4. Data Sharing</h2>
                <p>We do not sell your personal data. We may share your information with:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>AI service providers (Amazon Bedrock) for idea analysis</li>
                  <li>Cloud infrastructure providers (AWS) for data storage</li>
                  <li>Legal authorities when required by law</li>
                </ul>
              </section>

              <section>
                <h2 className="font-display text-2xl font-light tracking-tight text-white mb-4">5. Your Rights</h2>
                <p>You have the right to:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Access your personal data</li>
                  <li>Correct inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Object to data processing</li>
                  <li>Export your data</li>
                </ul>
              </section>

              <section>
                <h2 className="font-display text-2xl font-light tracking-tight text-white mb-4">6. Cookies</h2>
                <p>
                  We use essential cookies and local storage to maintain your session and preferences. 
                  We do not use tracking or advertising cookies.
                </p>
              </section>

              <section>
                <h2 className="font-display text-2xl font-light tracking-tight text-white mb-4">7. Contact Us</h2>
                <p>
                  If you have questions about this Privacy Policy, please contact us at:
                </p>
                <p className="text-sky-300 font-semibold">hello@opptora.ai</p>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer variant="public" onShowFeatures={onShowFeatures} onShowPricing={onShowPricing} onShowAbout={onShowAbout} onShowContact={onShowContact} onShowTerms={onShowTerms} />
    </div>
  )
}

PrivacyPolicy.propTypes = {
  onBack: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
  onShowFeatures: PropTypes.func.isRequired,
  onShowPricing: PropTypes.func.isRequired,
  onShowAbout: PropTypes.func,
  onShowContact: PropTypes.func,
  onShowTerms: PropTypes.func,
}

export default PrivacyPolicy
